export default __webpack_public_path__ + "static/media/SEA_7481.8751b271.jpg";